<!-- START OF MAIN -->
<main class="site-main">
    <!-- START OF INNER BANNER -->
    <section class="inner-banner back-img" style="background-image: url('assets/img/about-us-banner-new.jpg');">
        <div class="banner-stripes">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="banner-shape-wp wow fadeInRight for-des" data-wow-duration=".8s">
            <div class="banner-shape">
                <span class="stripe"></span>
                <span class="stripe stripe-secondary"></span>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="inner-banner-content-wp white-text text-center">
                        <div class="inner-banner-content wow fadeInUp" data-wow-duration=".8s">
                            <h2 class="h2-title mb-0 mt-5">About Us</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF INNER BANNER -->
    <!-- START OF ABOUT US -->
    <section class="about-us">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="about-us-content wow fadeInRight" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="sec-title">
                            <span class="sub-title">
                                <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                                ABOUT US
                            </span>
                            <p style="line-height: 30px;" class="mb-3">
                                <span class="text-theme fw-medium">GOLDOL</span> Lubricants is a certified manufacturer
                                of industrial oils, lubricants, and greases, committed to delivering customized
                                lubrication solutions for a wide range of industries. With our dedicated focus on
                                lubricant manufacturing, we GUARANTEE smooth and prompt delivery of our products
                                worldwide.
                            </p>
                            <p style="line-height: 30px;">
                                Our advanced formulations are designed to provide superior thermal and oxidation
                                stability, reducing friction, sludge, and varnish build-up. <span
                                    class="text-theme fw-medium">GOLDOL</span> lubricants enhance
                                engine longevity, allowing for extended drain intervals and superior wear protection,
                                ensuring your machinery and vehicles run at peak efficiency for longer periods.
                                At <span class="text-theme fw-medium">GOLDOL</span>, we don’t just provide lubricants—we engineer solutions that maximize
                                performance and reliability, helping you reduce maintenance costs and downtime.
                            </p>
                        </div>
                        <div class="sec-title mt-5">
                            <span class="sub-title text-uppercase">
                                <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                                Company History
                            </span>
                            <p style="line-height: 30px;">Founded in 1995, <span class="text-theme fw-medium">GOLDOL</span> Lubricants has been committed to providing high-quality lubricants to
                                industries across the region. Over the years, we have grown steadily, earning a reputation
                                for reliability and product excellence. From our humble beginnings, we’ve expanded our
                                product offerings and built strong relationships with clients in various sectors.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF ABOUT US -->

    <section class="how-we-work light-bg">
        <div class="container">
            <div class="sec-title text-center wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s"
                style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: fadeInUp;">
                <span class="sub-title text-uppercase">
                    <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                    Our Process
                </span>
                <h2 class="h3-title mb-5">See How We Work</h2>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-4 mb-4">
                    <div class="work-box wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s"
                        style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: fadeInUp;">
                        <span>01</span>
                        <h4 class="h4-title">Growth and Expansion</h4>
                        <p>
                            Since our establishment, we have continually evolved to meet the changing demands of the
                            market. From increasing our product line to enhancing our manufacturing capabilities, our
                            growth has been fueled by a focus on quality and performance.
                            We’ve expanded into new markets and industries, including automotive, heavy machinery, and
                            industrial applications, building our presence and ensuring prompt delivery to our clients
                            worldwide. As we move forward, we remain focused on innovation and operational excellence,
                            always looking for ways to improve and offer value to our clients.
                        </p>
                    </div>
                </div>
                <div class="col-md-4 mb-4">
                    <div class="work-box wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s"
                        style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: fadeInUp;">
                        <span>02</span>
                        <h4 class="h4-title">Certifications and Standards</h4>
                        <p>At GOLDOL Lubricants, we adhere to the highest industry standards to ensure that our products
                            meet the needs of our customers while complying with global regulations. Our manufacturing
                            processes are certified under ISO 9001:2015, guaranteeing that our products are consistent
                            in quality and performance. We are also committed to environmental sustainability and comply
                            with ISO 14001:2015, ensuring that our operations minimize environmental impact.
                            Additionally, we prioritize the safety and well-being of our employees by following the ISO
                            45001:2018 standards for occupational health and safety. These certifications reflect our
                            dedication to quality, environmental responsibility, and the well-being of our workforce.
                        </p>
                    </div>
                </div>
                <div class="col-md-4 mb-4">
                    <div class="work-box wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s"
                        style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: fadeInUp;">
                        <span>03</span>
                        <h4 class="h4-title">Research and Development</h4>
                        <p>At GOLDOL Lubricants, we believe that innovation is the key to staying ahead in the
                            lubricants industry. Our state-of-the-art R&D facility plays a crucial role in developing
                            advanced lubrication solutions that meet the evolving needs of various industries. Our team
                            of experienced chemists and engineers is dedicated to creating high-performance lubricants
                            that offer exceptional protection and efficiency for engines, machinery, and industrial
                            equipment. By continually investing in research and development, we ensure that our products
                            deliver superior quality, longer-lasting performance, and enhanced protection, giving our
                            clients a competitive edge in their respective fields.
                        </p>
                    </div>
                </div>
                <div class="col-md-4 mb-4">
                    <div class="work-box wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s"
                        style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: fadeInUp;">
                        <span>04</span>
                        <h4 class="h4-title">Global Reach</h4>
                        <p>With an established distribution network, GOLDOL Lubricants ensures that our products reach
                            customers across a wide range of geographical regions. Our global reach allows us to provide
                            prompt and efficient service to industries worldwide, with a focus on timely delivery and
                            customer satisfaction. We have built strong partnerships with key players in markets across
                            the Middle East, Asia, and beyond, ensuring that our lubricants meet the unique needs of
                            diverse sectors. Whether you're in automotive, industrial machinery, GOLDOL
                            is equipped to supply the products that enhance the efficiency and longevity of your
                            operations, no matter where you are located.</p>
                    </div>
                </div>
                <div class="col-md-4 mb-4">
                    <div class="work-box wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".2s"
                        style="visibility: visible; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: fadeInUp;">
                        <span>05</span>
                        <h4 class="h4-title">Sustainability Initiatives</h4>
                        <p>At GOLDOL Lubricants, we are committed to minimizing our environmental footprint and
                            promoting sustainability throughout our operations. Our manufacturing processes are designed
                            to reduce waste and energy consumption, and we are actively working toward greener
                            formulations that meet both performance and environmental standards. We use renewable energy
                            sources where possible and ensure responsible disposal practices for waste materials. In
                            addition, we are dedicated to recycling and reusing materials in our production processes.
                            Beyond our operations, we collaborate with partners to support sustainable practices across
                            the lubricants supply chain, reflecting our commitment to environmental stewardship and
                            creating a positive impact on the planet.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- START OF INNOVATIONS -->
    <section class="why-choose">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="why-choose-content wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="sec-title">
                            <span class="sub-title">
                                <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                                OUR VISION
                            </span>
                        </div>
                        <ul>
                            <li>
                                <span>
                                    To be recognized as a customer-centric, environmentally prudent, and an ethical
                                    producer of quality lubricants and greases.
                                </span>
                            </li>
                            <li>
                                <span>
                                    To create solutions that deliver benefits beyond equipment performance through
                                    operational efficiencies that positively impact our customers' bottom line.
                                </span>
                            </li>
                        </ul>

                        <div class="sec-title mt-5">
                            <span class="sub-title">
                                <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon">
                                OUR MISSION
                            </span>
                        </div>
                        <ul>
                            <li>
                                <span>Satisfaction of customer requirements.</span>
                            </li>
                            <li>
                                <span>Conducting business with ethics and integrity.</span>
                            </li>
                            <li>
                                <span>
                                    Associate with partners who will take pride in distributing our market
                                    relevant quality products.
                                </span>
                            </li>
                            <li>
                                <span>
                                    Told a framework of trust and understanding with all our customers and
                                    suppliers.
                                </span>
                            </li>
                            <li>
                                <span>
                                    Contributing positively to society and community uplifting initiatives.
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 align-self-lg-center">
                    <div class="why-choose-image-wp wow fadeInRight" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="row">
                            <div class="col-8">
                                <div class="why-choose-image why-choose-1 back-img"
                                    style="background-image: url('assets/img/our-vission.jpg');"></div>
                            </div>
                            <div class="col-4 align-self-center">
                                <div class="why-choose-image why-choose-2 back-img"
                                    style="background-image: url('assets/img/choose-us-2.jpg');"></div>
                            </div>
                            <div class="col-12">
                                <div class="why-choose-image why-choose-3 back-img"
                                    style="background-image: url('assets/img/our-mission.jpg');"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF INNOVATIONS -->
</main>
<!-- END OF MAIN -->